/**
 * 小売開栓結果登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約割引
 */
export interface Sgkb121aReqCtrDiscntsDto {
    /** 
     * 料金計算定義料金コード：半角英数混在
     */
    chargeCode?: string;
    /** 
     * 割引指定区分１：半角数字
     */
    discntSiteiDiv1?: string;
    /** 
     * 割引指定区分２：半角数字
     */
    discntSiteiDiv2?: string;
    /** 
     * 割引指定区分３：半角数字
     */
    discntSiteiDiv3?: string;
    /** 
     * 割引指定区分４：半角数字
     */
    discntSiteiDiv4?: string;
    /** 
     * 割引指定区分５：半角数字
     */
    discntSiteiDiv5?: string;
    /** 
     * 割引正式名称：全角文字
     */
    discntAname?: string;
    /** 
     * 割引略称名称：全角文字
     */
    discntRyaku?: string;
    /** 
     * 割引範囲開始値：半角数値(小数点あり)
     */
    discntRangeStart?: number;
    /** 
     * 割引範囲終了値：半角数値(小数点あり)
     */
    discntRangeEnd?: number;
    /** 
     * 割引タイプコード：半角英数混在
     */
    discntType?: string;
    /** 
     * 割引対象料金下限額：半角数値(小数点あり)
     */
    discntTargetMin?: number;
    /** 
     * 契約割引上限金額：半角数値(小数点あり)
     */
    discntMaxValue?: number;
    /** 
     * 契約割引パーセント：半角数値(小数点あり)
     */
    discntRate?: number;
}
